import { render, staticRenderFns } from "./IssuetrackingJobview.vue?vue&type=template&id=8057d672&"
import script from "./IssuetrackingJobview.vue?vue&type=script&lang=js&"
export * from "./IssuetrackingJobview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports